<template>
  <v-container>
    <v-dialog v-model="dialog" persistent max-width="400">
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          class="f-880 w-100 mt-3 mt-md-0 br-8"
          color="primary"
          small
          height="30"
          style="width: 100px"
          >Remover</v-btn
        >
      </template>
      <v-card class="px-3 py-7">
        <v-card-title
          class="justify-center text-center font-weight-bold f-12 primary--text pt-1 px-0"
          >Tem a certeza que deseja excluir esta <br />
          forma de pagamento?</v-card-title
        >
        <v-card-text
          v-if="type === 'Sepa'"
          class="text-center color-darkGray px-0"
          style="line-height: 17px"
          >Poderá adicionar outro Débito Direto (SEPA) a qualquer momento.</v-card-text
        >
        <v-card-text v-else class="text-center color-darkGray px-0" style="line-height: 17px"
          >Poderá adicionar outro cartão a qualquer momento.</v-card-text
        >
        <v-card-actions class="justify-center">
          <v-btn
            width="150"
            height="40"
            outlined
            color="gray"
            class="font-weight-bold"
            @click="dialog = false"
            >Cancelar</v-btn
          >
          <v-btn
            width="150"
            height="40"
            class="bg-danger color-white"
            @click="deletePatientCard(item.id)"
            >Remover</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: 'RemoveModalDialog',
  props: {
    type: { type: String },
    item: { type: Object },
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    deletePatientCard() {
      this.$emit('remove');

      this.dialog = false;
    },
  },
};
</script>

<style></style>
